
  (function() {
    // Textes traduits (rendus par coffret-product.liquid), repli sur le français
    var S = (window.phlameStrings && window.phlameStrings.coffret_product_js) || {};
    var dataEl = document.getElementById('pc-product-data');
    var productData = JSON.parse(dataEl.textContent || '{}');
    var variants = productData.variants;
    // URL localisées (/en-eu/…) : racine fournie par Shopify
    var PC_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Options repérées par position (calculées en Liquid), jamais par leur nom traduit
    function pcOptIdx(attr) { var n = parseInt(dataEl.getAttribute(attr), 10); return isNaN(n) ? -1 : n; }

    var mainImg = document.getElementById('pc-main-img');
    var thumbs = document.querySelectorAll('.pc-thumb');
    var dots = document.querySelectorAll('.pc-dot');
    var pcDefaultImg = mainImg ? mainImg.getAttribute('src') : '';

    // Change l'image principale et synchronise miniatures + points
    function pcSetMainImage(src) {
      if (!src || !mainImg) return;
      mainImg.style.opacity = '0';
      setTimeout(function() { mainImg.src = src; mainImg.style.opacity = '1'; }, 200);
      thumbs.forEach(function(b) { b.classList.toggle('is-active', b.getAttribute('data-img') === src); });
      dots.forEach(function(d) { d.classList.toggle('is-active', d.getAttribute('data-img') === src); });
    }

    thumbs.forEach(function(btn) {
      btn.addEventListener('click', function() { pcSetMainImage(btn.getAttribute('data-img')); });
    });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { pcSetMainImage(dot.getAttribute('data-img')); });
    });

    // Diffuseurs (Modèle) et bougies (Contenance) : n'affiche que les photos de la valeur choisie (data-model vide = photo commune, toujours visible)
    function pcFilterGallery(model) {
      [].slice.call(thumbs).concat([].slice.call(dots)).forEach(function(el) {
        var m = el.getAttribute('data-model') || '';
        el.hidden = !!m && m !== model;
      });
    }

    // === Configurateur « Personnalisez votre coffret » : cartes cliquables (gauche) → inputs cachés (form) ===
    function pcCfgSelect(el, value) {
      var input = document.getElementById('prop-' + el);
      if (input) input.value = value;
    }
    // Initialise chaque input caché avec la 1re option (carte .is-selected) de son groupe
    ['kheops', 'bat', 'recip', 'colorant', 'colorant2', 'recip2'].forEach(function(el) {
      var selected = document.querySelector('.pc-cfg-card.is-selected[data-cfg-el="' + el + '"]')
                  || document.querySelector('.pc-cfg-card[data-cfg-el="' + el + '"]');
      if (selected) pcCfgSelect(el, selected.getAttribute('data-cfg-value'));
    });
    document.querySelectorAll('.pc-cfg-card[data-cfg-el]').forEach(function(card) {
      // État de sélection exposé aux lecteurs d'écran
      card.setAttribute('aria-pressed', card.classList.contains('is-selected') ? 'true' : 'false');
      card.addEventListener('click', function() {
        var el = card.getAttribute('data-cfg-el');
        var value = card.getAttribute('data-cfg-value');
        pcCfgSelect(el, value);
        // Surligne la carte cliquée, dé-surligne ses sœurs du même groupe
        document.querySelectorAll('.pc-cfg-card[data-cfg-el="' + el + '"]').forEach(function(c) { c.classList.remove('is-selected'); c.setAttribute('aria-pressed', 'false'); });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        // Colorant : affiche la bougie teintée, ou revient à la 1re photo du produit pour « Naturel »
        if (card.hasAttribute('data-color-img')) {
          var colorImg = card.getAttribute('data-color-img');
          pcSetMainImage(colorImg || pcDefaultImg);
          var preview = document.getElementById('pc-color-preview');
          if (preview) {
            if (colorImg) { preview.src = colorImg; preview.alt = (S.preview_alt || 'Aperçu de la bougie [colour]').replace('[colour]', (card.textContent.trim() || value).toLowerCase()); }
            preview.style.display = colorImg ? 'block' : 'none';
          }
        }
      });
    });

    document.querySelectorAll('[data-section-toggle]').forEach(function(head) {
      head.addEventListener('click', function() {
        var section = head.closest('.pc-section');
        if (section) section.classList.toggle('is-open');
      });
    });

    var qtyInput = document.getElementById('pc-qty');
    var qtyMinus = document.getElementById('pc-qty-minus');
    var qtyPlus = document.getElementById('pc-qty-plus');

    // Prix total (quantité × prix unitaire), visible dès que qty > 1
    var totalEl = document.getElementById('pc-total');
    var totalVal = document.getElementById('pc-total-val');
    var totalQ = document.getElementById('pc-total-q');
    var pcUnitPrice = 0;
    (function initUnitPrice() {
      var cid = (document.getElementById('pc-variant-id') || {}).value;
      var cv = variants.find(function(v) { return String(v.id) === String(cid); });
      pcUnitPrice = cv ? cv.price : (variants[0] ? variants[0].price : 0);
    })();
    function updateTotal() {
      if (!totalEl || !totalVal || !qtyInput) return;
      var q = parseInt(qtyInput.value, 10) || 1;
      if (q > 1) {
        if (totalQ) totalQ.textContent = '(' + q + ')';
        totalVal.textContent = formatMoney(pcUnitPrice * q);
        totalEl.hidden = false;
      } else {
        totalEl.hidden = true;
      }
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
      updateTotal();
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
      updateTotal();
    });
    if (qtyInput) qtyInput.addEventListener('input', updateTotal);
    updateTotal();

    var selectedOptions = [];
    var selectedIdx = []; // index de la valeur choisie dans chaque option (indépendant de la langue)
    productData.options.forEach(function(opt, i) {
      var firstSelected = document.querySelector('.pc-option-btn.is-selected[data-option-index="' + i + '"]');
      selectedOptions[i] = firstSelected ? firstSelected.getAttribute('data-option-value') : null;
      selectedIdx[i] = firstSelected ? parseInt(firstSelected.getAttribute('data-value-index'), 10) : 0;
    });
    // Option « Modèle » / « Contenance » : photos filtrées par index de valeur (data-model = index)
    var modelOptIndex = pcOptIdx('data-model-opt');
    if (modelOptIndex >= 0) pcFilterGallery(String(selectedIdx[modelOptIndex]));

    // === Lot de 2 : sélection obligatoire d'une 2e senteur ===
    var secondWrap = document.getElementById('pc-second');
    var secondSelect = document.getElementById('pc-second-select');
    var secondScent = document.getElementById('pc-second-scent');
    var expressWrap = document.querySelector('.pc-express');
    var formatOptIndex = pcOptIdx('data-format-opt');
    var pcAvailable = true;

    // Lot = toute valeur de l'option « Format » autre que la 1re (À l'unité)
    function pcIsLot() {
      if (formatOptIndex < 0) return false;
      return (selectedIdx[formatOptIndex] || 0) >= 1;
    }
    // Affiche/masque le sélecteur, masque le paiement express en lot, bloque l'ajout tant que la 2e senteur n'est pas choisie
    // Options du 2e article (lot de 2) : actives seulement en lot, sinon non transmises
    function pcSyncLotExtras(lot) {
      ['colorant2', 'recip2'].forEach(function(el) {
        var inp = document.getElementById('prop-' + el);
        if (!inp) return;
        if (!lot) { inp.value = ''; return; }
        if (!inp.value) {
          var sel = document.querySelector('.pc-cfg-card.is-selected[data-cfg-el="' + el + '"]')
                 || document.querySelector('.pc-cfg-card[data-cfg-el="' + el + '"]');
          inp.value = sel ? sel.getAttribute('data-cfg-value') : '';
        }
      });
      var t = document.getElementById('pc-color-title');
      if (t) t.innerHTML = lot ? (S.colour_title_first || 'Colorant de la 1<sup>re</sup> bougie') : (S.colour_title || 'Colorant de la bougie');
    }

    function updateSecondScent() {
      if (formatOptIndex < 0 || !secondWrap) return;
      var lot = pcIsLot();
      if (expressWrap) expressWrap.style.display = lot ? 'none' : '';
      secondWrap.hidden = !lot;
      var addB = document.getElementById('pc-add-btn');
      if (!lot) {
        if (secondScent) secondScent.value = '';
        pcSyncLotExtras(false);
        return;
      }
      pcSyncLotExtras(lot);
      var chosen = secondSelect ? secondSelect.value : '';
      if (secondScent) secondScent.value = chosen || '';
      if (!pcAvailable || !addB) return;
      if (!chosen) {
        addB.disabled = true;
        addB.textContent = S.choose_second || 'Choisissez la 2ᵉ senteur';
        addB.classList.add('pc-btn--wait');
      } else {
        addB.disabled = false;
        addB.textContent = S.add_to_cart || 'Ajouter au panier';
        addB.classList.remove('pc-btn--wait');
      }
    }
    if (secondSelect) secondSelect.addEventListener('change', updateSecondScent);

    function updateVariant() {
      var match = variants.find(function(v) {
        return v.options.every(function(val, i) { return val === selectedOptions[i]; });
      });
      if (!match) return;
      document.getElementById('pc-variant-id').value = match.id;
      if (match.featured_image && match.featured_image.src) { pcSetMainImage(match.featured_image.src); }
      var priceEl = document.getElementById('pc-price');
      var priceEl2 = document.getElementById('pc-price-2');
      var priceFmt2 = document.getElementById('pc-price-2-fmt');
      var compareEl = document.getElementById('pc-compare');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (priceEl2) priceEl2.textContent = formatMoney(match.price);
      if (priceFmt2) priceFmt2.textContent = match.title;
      pcUnitPrice = match.price; updateTotal();
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      var availEl = document.getElementById('pc-availability');
      var addBtn = document.getElementById('pc-add-btn');
      var buyBtn = document.getElementById('pc-buy-btn');
      if (match.available) {
        availEl.textContent = S.in_stock || 'En stock'; availEl.classList.add('in-stock'); availEl.classList.remove('out-of-stock');
        addBtn.disabled = false; addBtn.textContent = S.add_to_cart || 'Ajouter au panier'; if (buyBtn) buyBtn.disabled = false;
      } else {
        availEl.textContent = S.sold_out || 'Épuisé'; availEl.classList.add('out-of-stock'); availEl.classList.remove('in-stock');
        addBtn.disabled = true; addBtn.textContent = S.unavailable || 'Indisponible'; if (buyBtn) buyBtn.disabled = true;
      }
      pcAvailable = match.available; updateSecondScent();
      productData.options.forEach(function(opt, i) {
        var lbl = document.getElementById('pc-opt-' + (i + 1));
        if (lbl) lbl.textContent = selectedOptions[i];
      });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    // Format éditorial localisé (FR « 12,00 € », EN « €12.00 ») ; repli identique à l'ancien format
    function formatMoney(cents) {
      if (typeof window.phlameFormatMoney === 'function') return window.phlameFormatMoney(cents);
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    document.querySelectorAll('.pc-option-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optIdx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-option-value');
        selectedOptions[optIdx] = val;
        selectedIdx[optIdx] = parseInt(btn.getAttribute('data-value-index'), 10) || 0;
        document.querySelectorAll('.pc-option-btn[data-option-index="' + optIdx + '"]').forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateVariant();
        if (modelOptIndex >= 0) pcFilterGallery(String(selectedIdx[modelOptIndex]));
      });
    });

    var form = document.getElementById('pc-form');
    var addBtn = document.getElementById('pc-add-btn');
    var buyBtn = document.getElementById('pc-buy-btn');

    if (form) form.addEventListener('submit', function(e) { e.preventDefault(); addToCart(false); });
    if (buyBtn) buyBtn.addEventListener('click', function() { addToCart(true); });

    function addToCart(redirectCheckout) {
      var variantId = document.getElementById('pc-variant-id').value;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var btn = redirectCheckout ? buyBtn : addBtn;
      var originalText = btn.textContent;
      btn.disabled = true; btn.textContent = S.adding || 'Ajout en cours...';
      // Récupère les propriétés de personnalisation (inputs cachés du formulaire)
      var payload = { id: variantId, quantity: qty };
      var props = {};
      if (form) {
        form.querySelectorAll('input[name^="properties["]').forEach(function(inp) {
          var m = inp.name.match(/^properties\[(.+)\]$/);
          if (m && inp.value) props[m[1]] = inp.value;
        });
      }
      if (Object.keys(props).length) payload.properties = props;
      // Colorant bougie : couleur ≠ Naturel → +2 € par bougie (add-on)
      var items = [payload];
      var c1 = document.getElementById('prop-colorant');
      var c2 = document.getElementById('prop-colorant2');
      var isLot = pcIsLot();
      var teintes = [];
      if (c1 && c1.value && c1.value !== 'Naturel') teintes.push(c1.value);
      if (isLot && c2 && c2.value && c2.value !== 'Naturel') teintes.push(c2.value);
      if (teintes.length) {
        items.push({ id: 58492657860943, quantity: qty * teintes.length,
          properties: { 'Colorant': teintes.join(' + '), 'Pour': 'Bougie personnalisée' } });
      }
      fetch(PC_ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(items.length > 1 ? { items: items } : payload)
      })
      .then(function(r) {
        // 422 (rupture, quantité indisponible) : Shopify renvoie un message lisible dans « description »
        return r.json().then(function(data) {
          if (!r.ok) throw new Error(data.description || data.message || '');
          return data;
        });
      })
      .then(function() {
        if (redirectCheckout) { window.location.href = PC_ROOT + 'cart'; return; }
        btn.textContent = S.added || 'Ajouté au panier';
        var openDrawer = function() {
          if (typeof phlameCartOpen === 'function') phlameCartOpen();
          else document.dispatchEvent(new CustomEvent('cart:open'));
        };
        if (typeof phlameCartRefresh === 'function') { phlameCartRefresh().then(openDrawer); }
        else { openDrawer(); }
        setTimeout(function() {
          btn.disabled = false; btn.textContent = originalText;
        }, 1500);
      })
      .catch(function(err) {
        btn.disabled = false; btn.textContent = originalText;
        alert((err && err.message) || S.error || 'Une erreur est survenue. Veuillez réessayer.');
      });
    }

    // État initial du sélecteur 2e senteur (selon la variante affichée au chargement)
    (function initSecond() {
      var cid = (document.getElementById('pc-variant-id') || {}).value;
      var cv = variants.find(function(v) { return String(v.id) === String(cid); });
      pcAvailable = cv ? cv.available !== false : true;
      updateSecondScent();
    })();
  })();
